export default __webpack_public_path__ + "static/media/tick.3985ed3f.mp3";